import Plyr from 'plyr';
import * as reveal from './reveal.js'

let next = document.querySelector(".bloc-portfolio__suivant");
let actif = document.querySelector(".bloc-portfolio__actif");
let allVideos = document.querySelectorAll('.video__conteneur')

let type = 'reference'


 // Vidéos réalisations
let players = null



export const initRealisation = () => {

    players = Plyr.setup('.bloc-portfolio__actif .video__zone__realisation', {
        youtube: { noCookie: true, start: 0.1},
        quality: 1080
        });
    next = document.querySelector(".bloc-portfolio__suivant");
    actif = document.querySelector(".bloc-portfolio__actif");

    // Click projet suivant
    next.querySelector('.section__header').addEventListener("click", clic);

    initVideo()   
}


export const initSection = () => {
        players = Plyr.setup('.video__zone__section', {
            youtube: { noCookie: true, start: 0.1},
            quality: 1080
        })
    initVideo()  
}



const clic = (e) => {
    if (!next.dataset.url) return

    pauseVideos()

    // Fixer la position du projet actif
    const posActif = actif.getBoundingClientRect()
    const posNext = next.getBoundingClientRect()

    actif.classList.add('bloc-portfolio__fixe')

    var domRect = next.getBoundingClientRect();
    var spaceBelow = window.innerHeight - domRect.bottom;

    var tailleFooter = getTailleFooter()
    var tailleNextRef = getTailleNextRef()
    var marge = window.innerHeight - (tailleNextRef.height + tailleFooter.height)

    actif.style.bottom = tailleNextRef.height + tailleFooter.height + 'px'

    //var domRect = next.getBoundingClientRect();
    //var spaceBelow = window.innerHeight - domRect.bottom;
    //console.log(spaceBelow,tailleFooter.height)

    // Fixer position projet suivant

    // Supprimé pour le test avec position relative
    next.style.position = 'fixed !important'
    next.style.transition = 'all 0s'
    next.style.marginTop = marge + 'px'


    setTimeout(function () {
        next.classList.add('bloc-portfolio__affiche')
        next.classList.add('goto-top')
    }, 100)


    document.body.scrollTop = document.documentElement.scrollTop = 0;


    let interval = setTimeout(function () {

        actif.remove()

        setUrl('/' + type + '/' + next.dataset.url, next.dataset.titre)

        next.classList.remove('bloc-portfolio__affiche')
        next.classList.remove('goto-top')
        next.classList.add('bloc-portfolio__actif') // le next devient l'actif

        next.classList.remove('bloc-portfolio__suivant')
        next.dataset.lien = ''

        // clean
        next.style.marginTop = ''
        next.style.position = ''
        next.style.top = ''
        next.removeAttribute('data-url');

        // ajout de la ref suivante
        var id = next.dataset.id
        getSuivant(id)

    }, 1500)


}


const getTailleFooter = function () {
    return document.querySelector('footer').getBoundingClientRect()
}

const getTailleNextRef = function () {
    return document.querySelector('.bloc-portfolio__suivant').getBoundingClientRect()
}

function setUrl(url, title) {
    var stateObj = {
        foo: "bar"
    };
    history.pushState(stateObj, title, url);
}


        

const initVideo = () => {
    allVideos = null
    allVideos = document.querySelectorAll('.video__conteneur')

   
    allVideos.forEach(element => {

        if ( !element.classList.contains('video__inactive') ) {
            element.addEventListener("click", function (e) {
                if (!element.classList.contains('is-active')) {
                    // Masquer toutes les vidéo
                    masqueVideos()
                    pauseVideos()

                    // Jouer la vidéo 
                    playVideoById(element.dataset.video)

                    // Afficher la vidéo active
                    setTimeout(() => {
                        element.classList.add('is-active')
                    }, 180);

                }
            })
        }
    });
}


const masqueVideos = () => {
    const posters = document.querySelectorAll('.video__conteneur')
    posters.forEach(element => {
        element.classList.remove('is-active')
    });
}

const pauseVideos = () => {
    players.forEach(element => {
        element.pause()
    });
}

const playVideoById = (id) => {
    players.forEach(element => {
        if (element.config.the_id == id) {
            element.play()
        }
    });
}





const getSuivant = (id) => {
   
    const url = 'https://' + window.location.host + '/wp-json/kashmir/v1/'+type+'/' + id + '/suivant'
    console.log(url)
    //console.log(url)
    fetch(url)
      .then((resp) => resp.json())
      .then(function (data) {
        
   
        actif.querySelector('.section__header').removeEventListener("click", clic);

        let nextNode = document.createElement("article")
        if (type == 'photos')  nextNode.classList.add('bloc-portfolio__photo')
        nextNode.classList.add('bloc-portfolio')
        nextNode.classList.add('bloc-portfolio__suivant')
        nextNode.dataset.id = data['next_ref'].ID
        nextNode.dataset.lien = 'reference'
        nextNode.dataset.url = data['next_ref'].post_name
        nextNode.dataset.title = data['next_ref'].post_title
        nextNode.innerHTML = data['next_ref'].html;
        
        let actifNode = document.querySelector(".bloc-portfolio__actif")
        actifNode.after(nextNode);
        

        setTimeout(() => {
            reveal.init() 
        }, 1000);
        initRealisation()

      })
      .catch(function (error) {
        console.log(error);
      });
  
  }

